import { createContext } from "react";
import {PaymentOnline2CompanyNamespace} from "../types/paymentOnline2Company.namespace";

const PaymentOnline2CompanyContext = createContext<PaymentOnline2CompanyNamespace.IContext>({
  selectedFactors: [],
});

export default PaymentOnline2CompanyContext;
